import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getEnrolleeOrderList } from '../common/enrollmentUtils';
import { enrollmentSchema } from '../common/premiumHistoryFormConfig';
import { IEnrollment } from '../common/types';

export const useEnrollmentFormContext = ({ isEdit }) => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};
    const { selectedEnrollment } = useSelector((state: { memberEnrollment: any }) => state.memberEnrollment);

    useEffect(() => {
        isEdit && methods.reset(getDefaultValues);
    }, [selectedEnrollment]);

    const getDefaultValues = useMemo(() => {
        let enrollment = {};
        if (!!selectedEnrollment) {
            const enroleeDataDtoList = getEnrolleeOrderList(selectedEnrollment?.enrolleeDataDtoList);

            enrollment = {
                enrollmentId: selectedEnrollment?.enrollmentId,
                householdId: selectedEnrollment?.houseHoldCaseId,
                enrollmentBenefitEffectiveStartDateUI: selectedEnrollment.enrollmentBenefitEffectiveStartDateUI,
                enrollmentBenefitEffectiveEndDateUI: selectedEnrollment.enrollmentBenefitEffectiveEndDateUI,
                enrolleeDataDtoList: enroleeDataDtoList,
                enrollmentPremiumDtoList: selectedEnrollment.enrollmentPremiumDtoList,
                enrollmentBenefitEffectiveStartMonth: selectedEnrollment.enrollmentBenefitEffectiveStartMonth,
                enrollmentBenefitEffectiveEndMonth: selectedEnrollment.enrollmentBenefitEffectiveEndMonth,
            };
        }

        return enrollment;
    }, [selectedEnrollment]);

    const methods = useForm<IEnrollment>({
        defaultValues: getDefaultValues,
        resolver: isEdit ? zodResolver(enrollmentSchema(selectedEnrollment, userPermissions)) : undefined,
        mode: 'all',
        reValidateMode: 'onChange',
    });

    return { ...methods };
};
